import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import { createNews, updateNews, fetchNewsDetail } from 'actions/News'
import { fetchCategories } from 'actions/Categories'
import FormNewsView from 'components/pages/news/Form'
import history from 'utils/history'
import Helper from 'utils/Helper'
import Browser from 'utils/Browser'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchNewsDetail: bindActionCreators(fetchNewsDetail, dispatch),
  fetchCategories: bindActionCreators(fetchCategories, dispatch),
  createNews: bindActionCreators(createNews, dispatch),
  updateNews: bindActionCreators(updateNews, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isSubmit', 'setIsSubmit', false),
  withState('isEdit', 'setIsEdit', false),
  withState('content', 'setContent', ''),
  withState('imgFile', 'setImgFile', ''),
  withState('currentImg', 'setCurrentImg', ''),
  withState('data', 'setData', {}),
  withState('newsContent', 'setNewsContent', ''),
  withState('categoryList', 'setCategoryList', {
    data: [],
    isFetching: true,
  }),
  withHandlers({
    getCategoryList: props => async (params) => {
      const { setCategoryList } = props
      props.fetchCategories(params)
        .then((res) => {
          setCategoryList({
            data: res.data,
            isFetching: false,
          })
        })
        .catch(() => {
          setCategoryList({
            data: [],
            isFetching: false,
          })
        })
    },
    getDetail: props => async (id) => {
      const {
        setData, setImgFile, setNewsContent,
        setCurrentImg,
      } = props
      try {
        const res = await props.fetchNewsDetail(id)
        setData(res)
        setNewsContent(res.content)
        setImgFile(res.image_name)
        setCurrentImg(res.image_name)
      } catch (err) {
        setData()
        setImgFile()
      }
    },
    handleUpload: props => (info) => {
      const isImage = Helper.checkingFile(info)
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (isImage && fileList.length > 0) {
        const base64 = Helper.getBase64(info.file, file => props.setImgFile(file))
        return base64
      }
      return false
    },
    handleChangeEditor: props => (values) => {
      props.setNewsContent(values)
    },
    handleSubmit: props => (values) => {
      let payload = {
        ...values,
        published_at: values.published_at.unix(),
        expired_at: values.expired_at.unix(),
      }

      props.setIsSubmit(true)

      if (props.imgFile === props.currentImg) {
        payload = {
          ...payload,
        }
        delete payload.image
      } else {
        payload = {
          ...payload,
          image: props.imgFile,
        }
      }

      if (props.isEdit) {
        props.updateNews(props.match.params.id, payload)
          .then(() => {
            message.success('Info & Berita sudah diperbarui')
            props.setIsSubmit(false)
            props.setImgFile('')
            props.setNewsContent('')
            Browser.setWindowHref('/news')
          })
          .catch(() => {
            props.setIsSubmit(false)
          })
      } else {
        props.createNews(payload)
          .then(() => {
            message.success('Info & Berita sudah dibuat')
            props.setIsSubmit(false)
            props.setImgFile('')
            props.setNewsContent('')
            Browser.setWindowHref('/news')
          })
          .catch(() => {
            props.setIsSubmit(false)
          })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        match, setIsEdit, getDetail, getCategoryList,
      } = this.props
      this.props.updateSiteConfigs({
        titlePage: 'Form Info & Berita',
        activePage: 'news',
        activeSubPage: 'news',
      })
      getCategoryList('?limit=1000')
      if (match.params.id) {
        setIsEdit(true)
        getDetail(match.params.id)
      }
    },
  }),
)(FormNewsView)
